// Dependencies
import React, { Component } from 'react';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import FormularioContactoModal from '../../subcomponents/FormularioContactoModal';
import image from '../../assets/img/vector/servidores-dedicados.svg';
import supermicro from '../../assets/img/brand/supermicro.svg';

import ImageText from '../../subcomponents/ImageText';
import IconBlock from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/servidordedicado1.svg';
import img2 from '../../assets/img/flat/servidordedicado2.svg';
import img3 from '../../assets/img/flat/servidordedicado3.svg';

class ServidoresDedicados extends Component {

    constructor(props) {
        super(props);
        this.state = { modalAsunto: 'Contacto' };
    }

    componentDidMount() {
        document.title = 'Servidores Dedicados - Insacom';
    }

    render() {

        let iconBlocks = [
            { id: 1, title: 'Redundancia Energética', description: 'Todos nuestros servidores cuentas con fuentes de poder redundantes', img: img1 },
            { id: 2, title: 'Personalización', description: 'Nos adaptamos a las configuraciones que nuestros clientes requieren', img: img2 },
            { id: 3, title: 'Acceso Remoto', description: 'Controla tu servidor de forma remota a través de IPMI', img: img3 }
        ];

        const description = "Si tus exigencias son las más altas y necesitas contar con hardware a la medida, contamos con una amplia variedad de equipos para soportar distintas cargas de trabajo.";

        return (
            <Section no-contact>
                <SectionContainer grey paddingBottom={'0px'}>
                    <ImageText
                        image={image}
                        brand={supermicro}
                        title="Servidores Dedicados"
                        description={description}></ImageText>
                </SectionContainer>
                <SectionContainer>
                    <IconBlock version={1} content={iconBlocks}></IconBlock>
                </SectionContainer>
                <SectionContainer grey>
                    <div className="row">
                        <div className="col-lg-6 g-mb-30">
                            <article className="w-100 d-sm-table g-bg-secondary ">
                                <div className="d-sm-table-cell text-center text-sm-left g-valign-middle g-brd-right--dashed--sm g-brd-gray-light-v4 g-pa-30">
                                    <div className="g-font-size-30 g-color-primary">4 UF</div>
                                    <em className="d-block g-font-style-normal g-font-weight-300 g-mt-minus-5 g-mb-20">desde</em>
                                    <button data-modal-target="#contacto-modal"
                                        onClick={() => {
                                            this.setState({ modalAsunto: 'Servidores Dedicados' })
                                        }} className="btn u-btn-outline-primary">Contactar</button>
                                </div>

                                <div className="d-sm-table-cell text-center text-sm-left g-valign-middle g-pa-30">
                                    <h4 className="text-uppercase g-color-black g-font-size-default g-font-weight-700">Servidores Dedicados</h4>
                                    <p className="mb-0">Contrata un servidor dedicado para cubrir tus necesidades más exigentes.</p>
                                </div>
                            </article>
                        </div>
                    </div>
                    <FormularioContactoModal asunto={this.state.modalAsunto} />
                </SectionContainer>
            </Section>
        );
    }
}

export default ServidoresDedicados;


// WEBPACK FOOTER //
// ./src/sections/datacenter/ServidoresDedicados.js